var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseApiClient } from "./BaseApiClient";
export var BREEDS_ENDPOINT = {
    GET: "/Breeds"
};
/**
 * BreedsApiClient - client for fetching Breeds from BFF endpoints
 * @export
 * @class BreedsApiClient
 * @extends {BaseApiClient}
 */
var BreedsApiClient = /** @class */ (function (_super) {
    __extends(BreedsApiClient, _super);
    function BreedsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch breeds from BFF
     * @throws {RequiredError}
     * @memberof BreedsApiClient
     */
    BreedsApiClient.prototype.getBreeds = function () {
        var fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(BREEDS_ENDPOINT.GET, fetchOptions);
    };
    return BreedsApiClient;
}(BaseApiClient));
export { BreedsApiClient };
//# sourceMappingURL=BreedsApiClient.js.map